module.exports = __webpack_public_path__ + "img/log-bg.66b40d9f.png";